import { dashboardT, type DashboardMessageKey } from '../../lib/messages';
import { ShigoRole } from './permissions';

const roleLabelKeys: Record<ShigoRole, DashboardMessageKey> = {
  [ShigoRole.SuperAdmin]: 'users.roles.superAdmin',
  [ShigoRole.Admin]: 'users.roles.admin',
  [ShigoRole.AdminReadOnly]: 'users.roles.adminReadOnly',
  [ShigoRole.User]: 'users.roles.user',
  [ShigoRole.UserReadOnly]: 'users.roles.userReadOnly',
  [ShigoRole.Agency]: 'users.roles.agency',
  [ShigoRole.Publisher]: 'users.roles.publisher',
  [ShigoRole.Advertiser]: 'users.roles.advertiser',
  [ShigoRole.AdvertiserReadOnly]: 'users.roles.advertiserReadOnly',
  [ShigoRole.Mcp]: 'users.roles.mcp',
  [ShigoRole.SalesRepresentative]: 'users.roles.salesRepresentative',
};

export function formatShigoRole(role: string) {
  const key: DashboardMessageKey | undefined = Object.hasOwn(roleLabelKeys, role)
    ? roleLabelKeys[role as ShigoRole]
    : undefined;
  return key ? dashboardT(key) : role.replaceAll('_', ' ');
}
